import { render } from "./EditProduct.vue?vue&type=template&id=da240d56&scoped=true&ts=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"

import "./EditProduct.vue?vue&type=style&index=0&id=da240d56&lang=css"
import "./EditProduct.vue?vue&type=style&index=1&id=da240d56&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da240d56"]])

export default __exports__